import * as actionTypes from './actionTypes';

export type Action = {
  action: string,
  payload?: boolean
};

export const cleanAdvisorError = () => (dispatch, getState) => {
  dispatch({
    type: actionTypes.ERROR_NO_CAPACITY,
    payload: false
  });
};

export const cleanDayTimeError = () => (dispatch, getState) => {
  dispatch({
    type: actionTypes.ERROR_DAY_TIME,
    payload: false
  });
};

export const cleanClutchError = () => (dispatch, getState) => {
  dispatch({
    type: actionTypes.ERROR_FROM_CLUTCH,
    payload: ''
  });
};



// WEBPACK FOOTER //
// ./src/store/reducers/errors/actions.js